var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-header"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.backButton),expression:"backButton"}],staticClass:"result-header__back",attrs:{"href":"/payment/library"}},[_c('span',[_vm._v("戻る")])]),_vm._v(" "),_c('span',{staticClass:"result-header__title"},[_vm._v("購入履歴")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82ffbc4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/ResultHeader.vue
// module id = null
// module chunks = 